'use strict';
(() => {
  const selector = [
    'main h1', 'main h2', '.jmo-footer-column h2',
    '.jmo-desktop-nav > a', '.jmo-menu-link', '.jmo-header-message'
  ].join(',');
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('jmo-type-visible', entry.isIntersecting));
  }, { threshold: 0.05 }) : null;
  const syncVisibility = () => document.body.classList.toggle('jmo-tab-hidden', document.hidden);
  document.addEventListener('visibilitychange', syncVisibility);
  syncVisibility();

  function decorate(root = document) {
    root.querySelectorAll(selector).forEach((element, index) => {
      if (element.dataset.jmoTypeReady) return;
      element.dataset.jmoTypeReady = 'true';
      const heading = /^H[12]$/.test(element.tagName);
      element.classList.add(heading ? 'jmo-type-heading' : 'jmo-type-navigation');
      element.style.setProperty('--jmo-type-delay', `${(index % 5) * -.6}s`);
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          if (!node.textContent.trim() || node.parentElement.closest('svg, script, style, .visually-hidden, [aria-hidden="true"], .jmo-type-ink')) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        const ink = document.createElement('span');
        ink.className = 'jmo-type-ink';
        node.replaceWith(ink);
        ink.append(node);
      });
      if (observer) observer.observe(element);
      else element.classList.add('jmo-type-visible');
    });
  }
  decorate();
  document.addEventListener('shopify:section:load', event => {
    decorate(event.target);
    });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-jmo-type-ready]').forEach(element => observer?.unobserve(element));
  });
})();
